import { Outlet, useNavigate } from 'react-router-dom'
import { Row, Col, } from '../../ui/ot'
import { useTranslation } from 'react-i18next'
import LibrarySwitch from './library_switch'
import { useState } from 'react'
import { LibraryContext } from './library_context';

const LibrarySwitchLayout = ({
    ...props
}) => {
    const [staffLibrary, setStaffLibrary] = useState({
        user_id: '',
        staff_id: '',
        branchcode: '',
        branchname: ''
    });
    return <LibraryContext.Provider value={staffLibrary}>
        <Row gutter={[4, 4]}>
            <Col span={24}>
                <Row justify="end">
                    <Col>
                        <LibrarySwitch
                            onChange={(value) => {
                                setStaffLibrary(value)
                            }}
                        />
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Outlet />
            </Col>
        </Row>
    </LibraryContext.Provider>
}
export default LibrarySwitchLayout